import { type MaterialImage, type MaterialImageDTO, type MaterialWeightsAndMeasures } from 'types'

import { mainSplitApi } from './redux/mainSplitApi'

const toMaterialImage = (materialImageDto: MaterialImageDTO): MaterialImage | undefined => {
  if (materialImageDto && materialImageDto.downloadUrl) {
    return { image: materialImageDto.downloadUrl }
  }
  return undefined
}

export const materialApi = mainSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchMaterialImage: builder.query<MaterialImage | undefined, string>({
      query: (productCode) => {
        return {
          url: `/materials/${productCode}/image`,
          method: 'GET'
        }
      },
      providesTags: (result, error, productCode) => [{ type: 'image', id: productCode }],
      transformResponse: (materialImageDto: MaterialImageDTO) => {
        return toMaterialImage(materialImageDto)
      }
    }),
    getWeightsAndMeasuresMissing: builder.query<MaterialWeightsAndMeasures, string>({
      query: (upc) => {
        return {
          url: '/materials',
          method: 'GET',
          params: { upc }
        }
      }
    })
  }),
  overrideExisting: false
})

export const { useFetchMaterialImageQuery, useGetWeightsAndMeasuresMissingQuery } = materialApi
